import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch } from "../hooks/hooks";
import { user } from "../redux/user/actions";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { addressBooks } from "../redux/address-books/action";
import storePersist from "../redux/storePersist";

export default function ProfileAddress() {
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [steps, setSteps] = useState<any>({})
	const { theme } = useSelector(selectCurrent)
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [color, setColor] = useState('universal')

	const dispatch = useAppDispatch();
	const handleClose = () => {
		dispatch(user.set({ viewProfile: 'close' }))
	}

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
	}, [theme]);
	const userProfileData = storePersist?.get("userProfile")?.current;
	const handleSave=()=>{
		dispatch(addressBooks.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/add-address-to-addressbook`,entity:'brands',jsonData:{
			
		"Records": [
			{
				AddressBookId: userProfileData?.items[0]?.AddressBookId,
				Addresses: [{
				  Id: 0,
				  FirstName: steps?.firstName,
				  LastName: steps?.lastName,
				  Email: steps?.emailAddress,
				  PhoneNumber: steps?.Phone,
				  Address1: steps?.Address1,
				  Address2: steps?.Address2,
				  City: steps?.City,
				  ZipPostalCode: steps?.PinCode,
				  StateProvinceId: '105',
				  CountryId: '133',
				}]
			  }
		]
	
}})).then (()=>{
	handleClose()
})
	}
	return (
		<>
				<div className={`absolute w-auto  mt-24 inset-5  z-10 h-[70vh] flex bg-[#233C64] rounded-xl shadow-lg justify-center`}>
				<div className="w-full  rounded-lg  flex flex-col  text-white p-5">
					<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
						<div className="flex w-full flex-col items-start justify-between text-xl" >
							Add Address
						</div>
						<div className="cursor-pointer">
							<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
						</div>
					</div>
					<div className="flex w-full flex-col space-y-3 px-8 py-6 overflow-auto" >
						<div className="w-full">
							<label
								className="block w-full text-sm font-light mb-2" >
								First Name
							</label>
							<input
								type="text"
								{...register('firstName', { required: true, maxLength: 15 })}
								className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="First Name"
								onChange={(e) => handleSteps(e, 'firstName')}
							/>
							{errors.firstName && errors.firstName.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.firstName && errors.firstName.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
						</div>
						<div className="w-full">
							<label
								className="block text-sm font-light mb-2" >
								Last Name
							</label>
							<input
								type="text"
								{...register('lastName', { required: true, maxLength: 30 })}
								className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="Last Name"
								onChange={(e) => handleSteps(e, 'lastName')}
							/>
							{errors.lastName && errors.lastName.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.lastName && errors.lastName.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
							<div className="w-full my-5">
								<label
									className="block w-full text-sm font-light mb-2" >
									Email Address*
								</label>
								<input
									type="text"
									{...register('emailAddress', {
										required: true,
										pattern:
											/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
									})}
									className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="Email Address"
									onChange={(e) => handleSteps(e, 'emailAddress')}
								/>
								{errors.emailAddress && errors.emailAddress.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.emailAddress && errors.emailAddress.type === "pattern" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
								)}
							</div>

							<div className="w-full my-5">
								<label
									className="block text-sm font-light mb-2" >
									Phone*
								</label>
								<input
									type="number"
									{...register('Phone', {
										required: true,
										maxLength: 10,
										minLength: 10,
										pattern: /^[0-9+-]+$/
									})}
									className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="Phone"
									onChange={(e) => handleSteps(e, 'Phone')}
								/>
								{errors.Phone && errors.Phone.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.Phone && errors.Phone.type === "maxLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
								{errors.Phone && errors.Phone.type === "minLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
								{errors.Phone && errors.Phone.type === "pattern" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
							</div>
						</div>
						<div className="w-full">
							<label
								className="block  text-sm font-light mb-2"
							>
								Address1 *
							</label>
							<textarea
								{...register('Address1', { required: true, maxLength: 30 })}
								className="border-0 px-3 py-3   text-black    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="Address1"
								onChange={(e) => handleSteps(e, 'Address1')}
							/>
							{errors.Address1 && errors.Address1.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.Address1 && errors.Address1.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
						</div>
						<div className="w-full">
							<label
								className="block  text-sm font-light mb-2"
							>
								Address2 *
							</label>
							<textarea
								{...register('Address2', { required: true, maxLength: 30 })}
								className="border-0 px-3 py-3   text-black    rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="Address2"
								onChange={(e) => handleSteps(e, 'Address2')}
							/>
							{errors.Address2 && errors.Address2.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.Address2 && errors.Address2.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
						</div>
						<div className="w-full">
							<label
								className="block text-sm font-light mb-2" >
								City*
							</label>
							<input
								type="text"
								{...register('City', { required: true, maxLength: 30 })}
								className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="City"
								onChange={(e) => handleSteps(e, 'City')}
							/>
							{errors.City && errors.City.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.City && errors.City.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
						</div>
						<div className="w-full">
							<label
								className="block   text-sm font-light mb-2"
							>
								PinCode*
							</label>
							<input
								type="text"
								{...register('PinCode', { required: true, maxLength: 30 })}
								className="border-0 px-3 py-3   text-black   rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
								placeholder="PinCode"
								onChange={(e) => handleSteps(e, 'PinCode')}
							/>
							{errors.PinCode && errors.PinCode.type === "required" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
							)}
							{errors.PinCode && errors.PinCode.type === "maxLength" && (
								<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
							)}
						</div>
					</div>
					<div className="w-full flex text-center mt-6">
					<button type="submit"
							className="bg-red-500 text-white text-xl p-2 w-full"
							onClick={handleSave}
						>Register  </button>
					</div>
				</div>
			</div >
		</>
	);
}